import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
    name: "HolidayDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_EXIST,
            isLoading: false,
            date: '',
            description: '',
            holidayData: {}
        };
    },

    methods: {
        dayOffLabel(val) {
            if (val === true || val === 1 || val === "1") return "Yes";
            if (val === false || val === 0 || val === "0") return "No";
            return "—";
        },

        enrichHolidayDisplay() {
            const h = this.holidayData;
            const catId = h.category_id !== null && h.category_id !== undefined && h.category_id !== ""
                ? Number(h.category_id)
                : null;
            const cats = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
            const cat = catId !== null && !Number.isNaN(catId)
                ? cats.find((c) => Number(c.id) === catId)
                : null;
            if (cat) {
                h.category_label = cat.label;
                h.category_color = cat.color_code;
            } else {
                h.category_label = "";
                h.category_color = "";
            }
            const typeOpts = CONFIG.HOLIDAY_TYPE_OPTIONS || {};
            const t = h.type;
            if (t !== null && t !== undefined && t !== "") {
                const key = Number(t);
                h.type_label = typeOpts[key] !== undefined ? typeOpts[key] : typeOpts[t] !== undefined ? typeOpts[t] : "—";
            } else {
                h.type_label = "—";
            }
        },

        getHolidayById() {
            axios.get('/holiday/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data != undefined) {
                        this.holidayData = response.data;
                        this.enrichHolidayDisplay();
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                  this.isLoading = false;
                });
        },
        showList() {
            this.$router.push({
                path: "/holiday/list"
            });
        },
    },
    mounted() {
        this.isLoading = true;
        this.getHolidayById();
    },
};
